import { css, cx } from '@onbeam/business-styled-system/css';
import Image from 'next/image';
import { ColorModeImageProps } from './ColorModeImage.types';

export const ColorModeImage = ({
  colorMode,
  className,
  ...props
}: ColorModeImageProps) => (
  <Image
    data-color-mode={colorMode}
    className={cx(
      css({
        '&[data-color-mode="light"]': {
          _dark: {
            display: 'none',
          },
        },
        '&[data-color-mode="dark"]': {
          _light: {
            display: 'none',
          },
        },
      }),
      className,
    )}
    {...props}
  />
);
